
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-52fe5a5e!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SpreadsheetConfig.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SpreadsheetConfig.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-52fe5a5e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SpreadsheetConfig.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/settings/SpreadsheetConfig.vue
// module id = 271
// module chunks = 2